export const InklePaySymbol = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_5723_7889"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="16"
      y="16"
      width="24"
      height="24"
    >
      <path d="M40 16H16V40H40V16Z" fill="white" />
    </mask>
    <g mask="url(#mask0_5723_7889)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 16H16L28 28H16L28 40H40L28 28H40L28 16Z"
        fill="url(#paint0_linear_5723_7889)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_5723_7889"
        x1="16"
        y1="28"
        x2="40"
        y2="28"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8B08FD" />
        <stop offset="1" stopColor="#5622FF" />
      </linearGradient>
    </defs>
  </svg>
);
